import { render, staticRenderFns } from "./AccountantAppsSelector.vue?vue&type=template&id=634d8224&scoped=true"
import script from "./AccountantAppsSelector.vue?vue&type=script&lang=js"
export * from "./AccountantAppsSelector.vue?vue&type=script&lang=js"
import style0 from "./AccountantAppsSelector.vue?vue&type=style&index=0&id=634d8224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d8224",
  null
  
)

export default component.exports